<template>
  <div>
    <Row>
      <Form ref="queryJobsInfoForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Input
          v-model="query.name"
          placeholder="请输入姓名"
          style="width:150px;margin-right: 10px;"
        />
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openJobsInfoDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="jobsInfoTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.jobsInfoTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="jobsInfoDrawer" :title="this.$t('drawer.title')[jobsInfoDrawer.type]" :visible.sync="jobsInfoDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <jobsInfo-form ref="jobsInfoForm"/>
        <div class="right-drawer__footer" v-if="jobsInfoDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="jobsInfoDrawer.submiting">{{ jobsInfoDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="jobsInfoDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import JobsInfoForm from '@/views/property/jobs-info/components/Form.vue';
Vue.component('jobsInfo-form', JobsInfoForm);

export default {
  name: 'aip-property-jobsInfo-index',
  mixins:[mixin],
  data () {
    return {
      query:{
          name:''
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      jobsInfoDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  methods: {
    handleBatchOperate(){
      let records = this.$refs.jobsInfoTable.getSelection()
      if (records.length == 0) {
        this.$Message.warning(this.$t('errorText'))
        return;
      }
      this[this.batchOperate.action](records)
    },
    handleSearch(){
      this.page.loading = true;
      api.property.JobsInfo.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openJobsInfoDrawer(jobsInfo){
      this.jobsInfoDrawer.visible = true
      this.jobsInfoDrawer.type = jobsInfo ? jobsInfo.type : 'add'
      this.$nextTick(()=>{
          if(jobsInfo){
              this.$refs['jobsInfoForm'].getJobsInfo(jobsInfo.id,jobsInfo.type)
          }else{
            this.$refs['jobsInfoForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.jobsInfoDrawer.submiting = true;
        this.$refs.jobsInfoForm.handleSubmit(
          data=>{
            this.jobsInfoDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.jobsInfoDrawer.visible=false, 1000);
          },
          ()=>{
            this.jobsInfoDrawer.submiting = false;
          }
        )
    },
    deleteJobsInfo(id){
      api.property.JobsInfo.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.property.JobsInfo.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          {key: 'id', width: 60, fixed:'left',type:'selection'},
          {key: 'name', align:'left',minWidth: 120,fixed:'left', title:  this.$t('property.jobs-info.name.label')},
          {key: 'remark', align:'left',minWidth: 120, title:  this.$t('property.jobs-info.remark.label')},
          {key: 'createTime', align: 'center', minWidth:120, title: this.$t('property.jobs-info.createTime.label'),},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 140,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openJobsInfoDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openJobsInfoDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true}
                      onOn-ok={()=>this.deleteJobsInfo(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
